<!-- eslint-disable @angular-eslint/template/alt-text -->
<div class="c-nav__all">
  <ul class="c-nav__menu">
    <div class="c-nav__header">
      <img class="c-nav__logo" src="assets/logos/logo-alerta.png" />
      <button class="c-nav__close-button" (click)="changeSidebarStatus()">
        <span class="material-symbols-rounded c-nav__icon">menu</span>
      </button>
    </div>
  </ul>
  <div class="c-nav__scrollable">
    <ul class="c-nav__menu">
      @for (m of menu(); track m.menuRolId; let idx = $index) {
        @if (m.children && m.children.length > 0) {
          <li
            #navItemRef
            class="c-nav__item"
            [routerLinkActive]="['show', 'active-link']"
            [ariaLabel]="idx"
          >
            <span
              class="c-nav__link"
              [attr.aria-hidden]="true"
              (click)="collapseNavItem(navItemRef)"
              (keyup)="(null)"
              [title]="m.title"
            >
              <div class="c-nav__content">
                <i
                  (click)="changeSidebarStatus()"
                  class="c-nav__icon material-symbols-rounded"
                  >{{ m.icono }}</i
                >
                <span class="c-nav__text">{{ m.title }}</span>
              </div>
              <i class="c-nav__arrow material-symbols-rounded">chevron_right</i>
            </span>
            <nav class="c-nav__sublink">
              @for (s of m.children; track s.menuRolId; let sidx = $index) {
                <a
                  class="c-nav__link"
                  [routerLink]="s.to"
                  routerLinkActive="c-nav__link--active"
                  [routerLinkActiveOptions]="{ exact: false }"
                  [title]="s.title"
                  (click)="changeSidebarStatus(true)"
                >
                  <div class="c-nav__content">
                    <span class="c-nav__icon material-symbols-rounded">{{
                      s.icono
                    }}</span>
                    <span class="c-nav__text">{{ s.title }}</span>
                  </div>
                </a>
              }
            </nav>
          </li>
        } @else {
          <li class="c-nav__item">
            <a
              class="c-nav__link"
              [routerLink]="m.to"
              routerLinkActive="c-nav__link--active"
              [routerLinkActiveOptions]="{ exact: true }"
              [title]="m.title"
              (click)="changeSidebarStatus(true)"
            >
              <div class="c-nav__content">
                <i class="c-nav__icon material-symbols-rounded">{{
                  m.icono
                }}</i>
                <span class="c-nav__text">{{ m.title }}</span>
              </div>
            </a>
          </li>
        }
      }
    </ul>
  </div>

  <div class="c-nav__footer">
    <ul class="c-nav__menu">
      <li class="c-nav__item mb-0">
        <a
          class="c-nav__link"
          routerLinkActive="c-nav__link--active"
          [routerLinkActiveOptions]="{ exact: true }"
          title="Salir"
          (keydown.enter)="logout()"
          (click)="logout()"
        >
          <div class="c-nav__content">
            <i class="c-nav__icon material-symbols-rounded">move_item</i>
            <span class="c-nav__text">Cerrar sesión</span>
          </div>
        </a>
      </li>
    </ul>
  </div>
</div>
